// extracted by mini-css-extract-plugin
module.exports = {"faEye":"faEye--28gWC","table":"table--1gvI0"};